import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import {
  Send, BarChart3, MousePointerClick, MailOpen
} from 'lucide-react';
import { useAdminEmail } from './AdminEmailContext';

const AnalyticsTab = () => {
  const ctx = useAdminEmail();
  const { emailStats, announcements, formatDate } = ctx;

  const avgOpenRate = announcements.length > 0
    ? Math.round(announcements.reduce((sum, a) => sum + (a.tracking?.open_rate || 0), 0) / announcements.length)
    : 0;
  const avgClickRate = announcements.length > 0
    ? Math.round(announcements.reduce((sum, a) => sum + (a.tracking?.click_rate || 0), 0) / announcements.length)
    : 0;

  return (
    <div className="analytics-tab">
      <Card className="analytics-card">
        <CardHeader>
          <CardTitle>Email Analytics</CardTitle>
          <CardDescription>Track email performance and engagement</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="analytics-overview">
            <div className="analytics-stat">
              <Send size={32} />
              <div>
                <span className="analytics-value">{emailStats?.announcements?.total_sent || 0}</span>
                <span className="analytics-label">Campaigns Sent</span>
              </div>
            </div>
            <div className="analytics-stat opens">
              <MailOpen size={32} />
              <div>
                <span className="analytics-value">{avgOpenRate}%</span>
                <span className="analytics-label">Avg Open Rate</span>
              </div>
            </div>
            <div className="analytics-stat clicks">
              <MousePointerClick size={32} />
              <div>
                <span className="analytics-value">{avgClickRate}%</span>
                <span className="analytics-label">Avg Click Rate</span>
              </div>
            </div>
          </div>

          <div className="analytics-section">
            <h3>Recent Campaign Performance</h3>
            {announcements.length === 0 ? (
              <div className="empty-state small">
                <BarChart3 size={32} />
                <p>No campaigns sent yet. Send your first announcement to see analytics.</p>
              </div>
            ) : (
              <div className="campaign-performance-list">
                {announcements.slice(0, 5).map((ann, idx) => (
                  <div key={idx} className="campaign-row" data-testid={`campaign-row-${idx}`}>
                    <div className="campaign-info">
                      <span className="campaign-title">{ann.title}</span>
                      <span className="campaign-date">{formatDate(ann.sent_at)}</span>
                    </div>
                    <div className="campaign-metrics">
                      <div className="metric">
                        <span className="metric-value">{ann.sent || 0}</span>
                        <span className="metric-label">Sent</span>
                      </div>
                      <div className="metric opens">
                        <span className="metric-value">{ann.tracking?.unique_opens || 0}</span>
                        <span className="metric-label">Opens ({ann.tracking?.open_rate || 0}%)</span>
                      </div>
                      <div className="metric clicks">
                        <span className="metric-value">{ann.tracking?.unique_clicks || 0}</span>
                        <span className="metric-label">Clicks ({ann.tracking?.click_rate || 0}%)</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="analytics-note">
            <p><strong>How it works:</strong> Emails include a tracking pixel for opens and wrapped links for clicks. Rates are calculated based on unique recipients.</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AnalyticsTab;
